import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { MissingPageComponent } from '../components/missing-page/missing-page.component';
import { DevEChartsChomponent } from '../dashboards/dev-echarts/dev-echarts.component';
import { LastArchonEngagementComponent } from '../dashboards/lastarchon-engagement/lastarchon-engagement.component';
import { LastArchonMasterComponent } from '../dashboards/lastarchon-masterdashboard/lastarchon-master.component';
import { LastArchonRetentionComponent } from '../dashboards/lastarchon-retention/lastarchon-retention.component';
import { LastArchonSalesComponent } from '../dashboards/lastarchon-sales/lastarchon-sales.component';
import { LastArchonUsersComponent } from '../dashboards/lastarchon-users/lastarchon-users.component';
import { JobsSummaryComponent } from '../pages/jobs/jobs-summary/jobs-summary.component';
import { OrchestratorComponent } from '../pages/jobs/orchestrator/orchestrator.component';
import { OrchestratorsComponent } from '../pages/jobs/orchestrators/orchestrators.component';
import { LoginComponent } from '../pages/login/login.component';
import { UnauthorizedComponent } from '../pages/unauthorized/unauthorized.component';
import { AuthService, GuardData } from '../services/auth.service';
import { NavbarData } from '../services/navbar/navbar.service';

/**
 * Routes are sorted the same way you want them to appear in the navbar
 */
export const dashboardsRoutes: DashboardRoute[] = [
    {
        path: 'lastarchon',
        name: 'Void Hunters',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewLastArchon } as GuardData,
        children: [
            {
                path: 'master',
                component: LastArchonMasterComponent,
                name: 'Master',
            },
            // {
            //     path: 'sales',
            //     component: LastArchonSalesComponent,
            //     name: 'Sales',
            // },
            {
                path: 'users',
                component: LastArchonUsersComponent,
                name: 'Users',
            },
            {
                path: 'retention',
                component: LastArchonRetentionComponent,
                name: 'Retention',
            },
            {
                path: 'engagement',
                component: LastArchonEngagementComponent,
                name: 'Engagement',
            },
        ],
    },
    {
        path: 'bladebound',
        name: 'Bladebound',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewBB } as GuardData,
        children: [
            {
                path: 'master',
                component: MissingPageComponent,
                name: 'Master',
                data: { disabled: true },
            },
            {
                path: 'sales',
                component: MissingPageComponent,
                name: 'Sales',
                data: { disabled: true },
            },
            {
                path: 'retention',
                component: MissingPageComponent,
                name: 'Retention',
                data: { disabled: true },
            },
            {
                path: 'engagement',
                component: MissingPageComponent,
                name: 'Engagement',
                data: { disabled: true },
            },
            {
                path: 'campaigns',
                component: MissingPageComponent,
                name: 'Campaigns',
                data: { disabled: true },
            },
        ],
    },
    {
        path: 'companytech',
        name: 'Company Tech',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewCompany } as GuardData,
        children: [],
    },
    {
        path: 'dev',
        name: 'Dev',
        canActivate: [AuthService],
        data: { canView: AuthService.canViewCompany } as GuardData,
        children: [
            {
                path: 'echarts',
                component: DevEChartsChomponent,
                name: 'Echarts use cases',
                data: {
                    navbarGroup: 'Dev',
                },
            },
        ],
    },
];

const routes: Routes = [
    // redirect
    { path: '', redirectTo: 'dashboards/lastarchon/master', pathMatch: 'full' },

    // login
    { path: 'login', component: LoginComponent },

    // authenticated
    {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        canActivate: [AuthService],
    },
    {
        path: 'dashboards',
        children: dashboardsRoutes,
    },
    {
        path: 'jobs',
        canActivate: [AuthService],
        title: 'Jobs',
        children: [
            { path: 'summary', component: JobsSummaryComponent },
            { path: 'orchestrators', component: OrchestratorsComponent },
            { path: 'orchestrators/:id', component: OrchestratorComponent },
        ],
    },
    { path: '**', component: MissingPageComponent, canActivate: [AuthService] },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}

export interface DashboardRoute extends Route {
    name: string;
    data?: GuardData | NavbarData;
    route?: string[];
    children?: DashboardRoute[];
}
